export default {
  PLACED: "PLACED",
  FULFILLING: "FULFILLING",
  FULFILLED: "FULFILLED",
  SHIPPED: "SHIPPED",
  DELIVERED: "DELIVERED",
  CANCELED: "CANCELED",
}
